<template>
  <div class="approvals">

    <!-- Category Inspiration
    https://www.asos.com/au/women/
    https://www.shopbop.com/clothing/br/v=1/13266.htm
    https://aus.spell.co/collections/bottoms
    https://www.net-a-porter.com/en-au/shop/clothing/jeans -->


    <div class="approvals__grid">
      <div class="approvals__grid-item" :class="{'approvals__grid-item--promoted': product.display_state >= display_state.PROMOTE_ON_SITE }" v-for="(product, index) in shopify_products" :key="index">
        <div class="approvals__grid-item-image-container">
          <img :src="product.small_image_url" />

          <div class="approvals__grid-item-overlay">

            <div class="approvals__columns approvals__columns--space-between">
              <div>Index: {{ index }}</div>
              <div>{{ displayState(product) }}</div>
            </div>

            <div class="approvals__columns">
              Image: {{ product.main_image_index }}
              <a @click.prevent="incrementImageIndex(product, -1)">Prev</a>
              <a @click.prevent="incrementImageIndex(product, 1)">Next</a>
            </div>

            <select class="approvals__top-margin" v-model="product.category_object" style="font-size:12px;">
              <option v-for="(category, category_index) in categories" :key="category_index" :value="category">{{ category.title }}</option>
            </select>

            <div class="approvals__top-margin">Product Type: {{product.product_type}}</div>

            <div class="approvals__top-margin">Vendor: {{product.vendor }}</div>

            <div class="approvals__top-margin">Available: {{product.available }}</div>

           <!-- <div class="approvals__columns">
              <div>Tags:</div>
              <div v-html="product.tags.join('<br />')"></div>
            </div> -->
          </div>
        </div>


        <div class="approvals__top-margin">
          <a :href="product.origin_url" target="_blank">{{ product.title }}</a>
        </div>

        <div class="approvals__columns">
          <router-link :to="admin_site_path(product.potential_shopify_site_document_id)">{{ product.shopify_site_document_id }}</router-link>
          <div>{{ product.published_at.toDate().toLocaleDateString('en-GB')}}</div>
          <div>${{product.variants[0].price}}</div>
        </div>

        <div class="approvals__top-margin">{{product.category}} - {{product.subcategory}}</div>

        <div class="approvals__top-margin">Available: {{product.available }}</div>

        <div class="approvals__columns">
         <!-- <a class="admin__button" @click="setDisplayState(product, display_state.NOT_SET, index)">Not Set</a> -->
          <a class="admin__button admin__button--red" @click="setDisplayState(product, display_state.HIDE_FROM_SITE, index)">Reject</a>
          <a class="admin__button admin__button--dark-green" v-if="product.subcategory && product.display_state == display_state.PROMOTE_ON_SITE" @click="setDisplayState(product, display_state.SHOW_ON_SITE, index)">Demote</a>
          <a class="admin__button admin__button--dark-green" v-if="product.subcategory && product.display_state == display_state.SHOW_ON_SITE" @click="setDisplayState(product, display_state.PROMOTE_ON_SITE, index)">Promote</a>
          <a class="admin__button admin__button--yellow" v-if="product.subcategory" @click="addToSocialPost(product)">Social</a>
        </div>

      </div>
    </div>

    <div style="margin-top: 20px;">
      <a class="admin__link" @click="nextPage__clicked">Next Page</a>
    </div>

    <social-generator ref="social_generator"></social-generator>
  </div>
</template>

<script>

import ShopifyProduct from '../../../models/ShopifyProduct'
import Category from "../../../models/Category";
import SocialGenerator from "../../../components/admin/social-generator";


import Facebook from "../../../utilites/facebook";
import SocialPost from "../../../models/SocialPost";

export default {
  components:{
    SocialGenerator
  },
  data(){
    return{
      facebook_app_id: "658631525168830",
      facebook_page_id: "107332291826523",
      instagram_account_id: "17841451518821060",
      facebook_access_token: null,
      shopify_products: [],
      categories: Category.toFlatArray(),
      display_state: ShopifyProduct.DisplayState
    }
  },
  async mounted(){
    await this.loadProducts();
  },
  computed:{

  },
  methods: {
    async loadProducts(){
      this.shopify_products = await ShopifyProduct.approvedProductsPage();
    },
    async nextPage__clicked(event){
      this.shopify_products = await ShopifyProduct.approvedProductsPage( this.lastProductPublishedDate() );
      window.scroll({top: 0, left: 0, behavior: 'smooth'});
    },


    displayState(product){
      //let prices = product.variants.map(variant => variant.price);// filter((value, index, self) => self.indexOf(value) === index);
      //Math.min(...prices)
      //return  Math.min(...prices) + ' ' + Math.max(...prices); //
      return ShopifyProduct.DisplayState.name(product.display_state);// + ': ' + product.display_state;
    },
    subcategoriesForProduct(product){
      return product.category ? this.categories.find( c => c.name == product.category).subcategories : [];
    },
    async setDisplayState(product, display_state, array_index){
        product.display_state = display_state;
        console.log("ds", product.display_state);
        await product.save();
        if(display_state == ShopifyProduct.DisplayState.HIDE_FROM_SITE )
          this.shopify_products.splice(array_index, 1);
    },

    lastProductPublishedDate(){
      return this.shopify_products[this.shopify_products.length - 1].published_at.toDate();
    },
    incrementImageIndex(product, direction){
      product.main_image_index = Math.max(0, Math.min(product.images.length - 1, parseInt(product.main_image_index) + direction));
    },

    async addToSocialPost(product){
      let latestPost = await SocialPost.latestPost();
      await latestPost.addProduct(product)

      product.display_state = ShopifyProduct.DisplayState.PROMOTE_ON_SITE;
      await product.save();

      await this.$refs.social_generator.refresh();
    }
  }

}
</script>
